import { Stack, Typography, useTheme } from "@mui/material";
import { ChevronRightIcon } from "lucide-react";
import type { FC, ReactNode } from "react";
import { InvestmentPropertyBadge } from "web_myplann/Portfolio/Components/Redesign/ListItem/InvestmentPropertyBadge";
import { MissingValueBadge } from "web_myplann/Portfolio/Components/Redesign/ListItem/MissingValueBadge";

type Props = {
	icon: ReactNode;
	title: string;
	subtitle: string | null;
	isInvestment?: boolean;
	isMissingValue: boolean;
	right: ReactNode;
	onClick: () => void;
};

export const PortfolioRow: FC<Props> = ({
	icon,
	title,
	subtitle,
	isInvestment = false,
	isMissingValue,
	right,
	onClick,
}) => {
	const theme = useTheme();
	return (
		<Stack
			direction="row"
			alignItems="center"
			gap={theme.spacingTokens.md}
			onClick={onClick}
			px={theme.spacingTokens.lg}
			py={1.4}
			sx={{
				cursor: "pointer",
				"&:active": { bgcolor: theme.palette.grey[100] },
			}}
		>
			{icon}
			<Stack flex={1} minWidth={0} gap={theme.spacingTokens.xs}>
				<Stack minWidth={0}>
					<Typography
						variant="bodyMedium"
						color={theme.palette.grey[900]}
						noWrap
					>
						{title}
					</Typography>
					{subtitle && (
						<Typography
							variant="caption"
							color={theme.palette.grey[500]}
							noWrap
						>
							{subtitle}
						</Typography>
					)}
				</Stack>
				{(isInvestment || isMissingValue) && (
					<Stack direction="row" gap={theme.spacingTokens.xs}>
						{isInvestment && <InvestmentPropertyBadge />}
						{isMissingValue && <MissingValueBadge />}
					</Stack>
				)}
			</Stack>
			<Stack alignItems="flex-end" flexShrink={0}>
				{right}
			</Stack>
			<ChevronRightIcon
				size={theme.iconSize.sm}
				color={theme.palette.grey[400]}
			/>
		</Stack>
	);
};
